import Vue from 'vue';
import { RootPage } from '@/types/pageContract';
import { File } from '@/types/contentContract';
import { axiosInstance } from '@/util/axiosInitializer';

export enum HighslideMode {
  Video,
  Image,
  Timeline,
  InterActivity,
  ReadOnlyContent
}

export interface IHighslideState {
  wideImage: File | null;
  originalImage: File | null;
  active: boolean;
  mediaLabel: string;
  imageCaption: string;
  mode: HighslideMode;
  embedUrl: string;
  readOnlyContent: RootPage | null;
}

const state: IHighslideState = Vue.observable({
  wideImage: null,
  originalImage: null,
  mediaLabel: '',
  active: false,
  imageCaption: '',
  mode: HighslideMode.Image,
  embedUrl: '',
  readOnlyContent: null
});

class HighslideStore {
  public get readOnlyContent(): RootPage | null {
    return state.readOnlyContent;
  }

  public get originalImage(): File | null {
    return state.originalImage;
  }

  public set originalImage(image: File | null) {
    state.originalImage = image;
  }

  public get embedUrl(): string {
    return state.embedUrl;
  }

  public set embedUrl(url: string) {
    state.embedUrl = url;
  }

  public get highslideWideImage(): File | null {
    return state.wideImage || null;
  }

  public set highslideWideImage(image: File | null) {
    state.wideImage = image;
  }

  public get highslideMode(): HighslideMode {
    return state.mode;
  }

  public set highslideMode(mode: HighslideMode) {
    state.mode = mode;
  }

  public get highslideActive(): boolean {
    return state.active;
  }

  public get mediaLabel(): string {
    return state.mediaLabel;
  }

  public set mediaLabel(label: string) {
    state.mediaLabel = label;
  }

  public get imageMetaDataCaption(): string {
    return state.imageCaption;
  }

  public set imageMetaDataCaption(caption: string) {
    state.imageCaption = caption;
  }

  public showHighslide(): void {
    state.active = true;
  }

  public closeHighslide(): void {
    state.active = false;
    state.wideImage = null;
    state.embedUrl = '';
  }

  public async getReadOnlyContent(queryUrl: string) {
    if (!queryUrl) {
      return;
    }

    state.readOnlyContent = null;

    const res = await axiosInstance.$get(`${queryUrl}`);

    if (res) {
      state.readOnlyContent = res;
    }
  }
}

export default new HighslideStore();
